import React, { useState } from "react";
import { Typography, TextArea, Button } from "components/atoms";
import {ReviewStars} from "../../../atoms/ReviewStars";
import { AI_CHAT_CLOSE_FEEDBACK, AI_CHAT_SEND_FEEDBACK } from "utils/constants/GoogleTagGUIDs";

interface IProps {
  theme: "light" | "dark";
  onSend: (rating: number, feedback: string) => void;
  onClose: () => void;
  disabled?: boolean;
}

export const ReviewSection = ({ theme, onSend, onClose, disabled = false }: IProps) => {
  const [reviewCount, setReviewCount] = useState<number[]>([]);
  const [reviewHoverCount, setReviewHoverCount] = useState<number[]>([]);
  const [reviewMessage, setReviewMessage] = useState<string>("");
  const [isTryingToSend, setIsTryingToSend] = useState<boolean>(false);

  // this use to store the review star count
  const handleReviewCount = (index: number) => {
    var temp: number[] = [];
    for (var i = 0; i < index + 1; i++) {
      temp.push(i);
    }
    setReviewCount(temp);
    setIsTryingToSend(false);
  };

  // this use to store the star count when hovering
  const handleReviewCountHoverEnter = (index: number) => {
    var temp: number[] = [];
    for (var i = 0; i < index + 1; i++) {
      temp.push(i);
    }
    setReviewHoverCount(temp);
    setIsTryingToSend(false);
  };

  // on blur effect when there is no hovering
  const handleReviewCountHoverLeave = () => {
    setReviewHoverCount([]);
    setIsTryingToSend(false)
  };

  // use to do the pre validation before sending a review
  const handleOnSend = () => {
      if (reviewCount?.length > 0) {
          resetState();
          onSend(reviewCount?.length, reviewMessage);
      } else {
          setIsTryingToSend(true);
      }
  }

    // use to do the closing part
    const handleOnClose = () => {
        resetState();
        onClose();
    }

  // use to reset the state
  const resetState = () => {
      setReviewCount([]);
      setReviewHoverCount([]);
      setReviewMessage("");
      setIsTryingToSend(false);
  }

  if (disabled) {
    // Practice review mode - show simplified close-only interface
    return (
      <div className="review-section-wrapper">
        <Typography
          variant="h7Light"
          label="Practice Review Session Complete"
          styles="ai-reviw-title"
        />
        <Typography
          variant="h7Book"
          label="Thank you for using the AI Tutor for practice review. Your session has been completed."
          styles="ai-review-practice-message"
        />
        <div className="ai-review-btn-wrapper">
          <Button
            label="Close"
            icon={false}
            type="score"
            styles="ai-review-btn"
            onClick={handleOnClose}
            dataTrackingId={AI_CHAT_CLOSE_FEEDBACK}
          />
        </div>
      </div>
    );
  }

  // Normal mode - show full feedback form
  return (
    <div className="review-section-wrapper">
      <Typography
        variant="h7Light"
        label="How would you rate your AI Tutor session?"
        styles="ai-reviw-title"
      />
      <div className="rating-star-wrapper">
        {Array.from({ length: 5 }, (_, index) => (
          <ReviewStars
            key={index}
            theme={theme}
            isSelected={
              reviewHoverCount.length > 0
                ? reviewHoverCount.includes(index)
                : reviewCount.includes(index)
            }
            onClick={() => handleReviewCount(index)}
            onOver={() => handleReviewCountHoverEnter(index)}
            onOut={handleReviewCountHoverLeave}
          />
        ))}
      </div>

      <TextArea
          value={reviewMessage}
          setValue={setReviewMessage}
          placeholder="Tell us more!"
          style="ai-reviw-text-area"
      />
      <div className="ai-review-btn-wrapper">
        <Button
          label="Close"
          icon={false}
          type="filter"
          styles="ai-review-btn ai-review-btn-filter"
          onClick={handleOnClose}
          dataTrackingId={AI_CHAT_CLOSE_FEEDBACK}
        />
        <Button
          label="Send"
          icon={false}
          type="score"
          styles="ai-review-btn "
          onClick={handleOnSend}
          dataTrackingId={AI_CHAT_SEND_FEEDBACK}
        />
      </div>
        {
            reviewCount.length === 0 && isTryingToSend &&
            <Typography
                variant="h7Book"
                label="please provide a rating"
                styles="ai-reviw-bottom-text"
            />
        }
    </div>
  );
};